import { BnAction } from '../../common/bn-action';
import { sharedStyles } from '../../styles/shared-styles';
import { css } from '../../utility/lit-entity';

class LocationUnassignButton extends BnAction {
  constructor() {
    super();
    this.actionname = 'unassign-installer';
    this.errortext = 'Failed to unassign work order location.';
    this.successtext = 'Work Order Location has been unassigned.';
    this.submittext = 'Unassign';
    this.suppressheader = true;
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: inline-block;
      }
    `];
  }

  preSubmit() {
    const confirmMessage = 'Are you sure you want to unassign work order location?';
    return window.confirm(confirmMessage);
  }
}

window.customElements.define('location-unassign-button', LocationUnassignButton);
